/* @flow */
import React, { Component } from 'react';
import { css } from 'linaria';

import MediaQueries from '../constants/MediaQueries';
import PhoneFrame from './PhoneFrame';
import { zip } from '../../utils';
import ZIndex from '../constants/ZIndex';

class PhoneRow extends Component<{
  sources: [{ src: string, src2x?: string }],
}> {
  render() {
    let { sources } = this.props;

    return (
      <div className={Styles.Container}>
        {zip(sources, [Styles.FirstItem, Styles.SecondItem, Styles.ThirdItem]).map((item, i) => {
          let [srcSet, styles] = item;
          return (
            <div className={styles} key={i}>
              <PhoneFrame size="small" {...srcSet} />
            </div>
          );
        })}
      </div>
    );
  }
}
const Styles = {
  Container: css`
    position: relative;
    width: 100%;
    display: block;
  `,
  OnlyItem: css`
    display: inline-block;
  `,
  FirstItem: css`
    position: relative;
    z-index: ${ZIndex.Higher};
  `,
  SecondItem: css`
    position: absolute;
    top: 0;
    right: 50%;
    margin-right: -80px; /* half the width of the phone frame */
    z-index: ${ZIndex.High};
    ${MediaQueries.SmallCapped} {
      padding-top: 10px;
    }
    ${MediaQueries.MediumCapped} {
      transform: scale(0.9);
    }
  `,
  ThirdItem: css`
    position: absolute;
    top: 0;
    right: 0;
    z-index: ${ZIndex.Low};
    ${MediaQueries.SmallCapped} {
      padding-Top: 20px;
    },
    ${MediaQueries.MediumCapped} {
      transform: scale(0.8);
    },
  `,
};

export default PhoneRow;



// WEBPACK FOOTER //
// ./src/ui/components/PhoneRow.js